import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GuestFindAllRequest,
  GuestFindAllResponse,
  GuestFindRequest,
  GuestFindResponse,
  GuestRemoveRequest,
  GuestRemoveResponse,
  GuestSaveRequest,
  GuestSaveResponse,
} from '../dto';

export abstract class GuestRepository {
  abstract findAllPath(uploadId: number): string;
  abstract findAll(payload: GuestFindAllRequest): Observable<HttpResponse<GuestFindAllResponse>>;
  abstract find(payload: GuestFindRequest): Observable<HttpResponse<GuestFindResponse>>;
  abstract save(payload: GuestSaveRequest): Observable<HttpResponse<GuestSaveResponse>>;
  abstract remove(payload: GuestRemoveRequest): Observable<HttpResponse<GuestRemoveResponse>>;
}



